export default __webpack_public_path__ + "static/media/docplus.cac78378.svg";